import endpoints from "../constants/endpoints";
import { fetchWrapper } from "../helpers/fetchWrapper";

export const SyndicateService = {
  getPage,
  getById,
  save,
  delete: _delete,
};

function getById(id) {
  return fetchWrapper.get(endpoints.SYNDICATES.GET_BY_ID + id);
}
function getPage(params) {
  return fetchWrapper.post(endpoints.SYNDICATES.GET, params);
}
function save(params) {
  return fetchWrapper.post(endpoints.SYNDICATES.SAVE, params);
}
function _delete(params) {
  return fetchWrapper.post(endpoints.SYNDICATES.SET_STATUS, params);
}
